<template>
  <div
    class="sf-virtual-table__header-cell"
    data-testid="sf-virtual-table-header-cell"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-virtual-table__header-cell {
  @include table-header-cell;

  border-top-style: none;
  border-left-style: none;
  border-bottom-style: none;

  &:last-child {
    border-right: 0;
  }
}
</style>
